<mat-toolbar class="p-0 mat-elevation-z1">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-icon-button class="navbar-toggle-button" *ngIf="!hiddenNavbar && !rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">apps</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="assets/images/logos/fuse.svg">
                </div>
            </div>

            <!-- <div class="px-8 px-md-16">
                <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>
            </div> -->

        </div>

        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

            <span class="dateFormat" *ngIf="ToolbarExterno">{{'TOOLBAR.LOGIN' | translate}} {{logDate | date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{city_name | translate}} {{logDate |date:'O':offsetPipe:idiomaActual}})</span>
            <button mat-button fxHide fxShow.gt-xs class="language-button" [matMenuTriggerFor]="languageMenu">
              <div fxLayout="row" fxLayoutAlign="center center">
                  <mat-icon>language</mat-icon>
                  <!-- <img class="flag mr-8" [src]="'assets/langIco/'+selectedLanguage.flag+'.png'" style="width:16px;height:11px;"> -->
                  <span class="iso text-uppercase">{{selectedLanguage.short}}</span>
              </div>
          </button>

            <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)">
                  <span fxLayout="row" fxLayoutAlign="start center">
                      <!-- <img class="flag mr-16" [src]="'assets/langIco/'+lang.flag+'.png'"  style="width:16px;height:11px;"> -->
                      <mat-icon>language</mat-icon>
                      <!-- <span class="iso">{{lang.title}}</span> -->
                      <span class="iso">{{'SELECTOR.'+lang.id | translate}}</span>
                  </span>
              </button>


            </mat-menu>

            <div class="toolbar-separator"></div>

            <button *ngIf="datosUsu" mat-button [matMenuTriggerFor]="userMenu" class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <!-- <img class="avatar mr-0 mr-sm-16" src="assets/images/avatars/{{datosUsuario.avatar}}.jpg"> -->
                    <img class="avatar mr-0 mr-sm-16" src="{{rutaimagen}}">
                    <!-- <span class="username mr-12" fxHide fxShow.gt-sm><span class="userItbm">oscar.burgos@itbm.mx, <em>conectado como:</em></span><br>{{datosUsuario.nombre}}</span> -->
                    <span class="username mr-12" fxHide fxShow.gt-sm>
                      <ng-container *ngIf="datosAdmin">
                        <span class="userItbm">{{datosAdmin.user}}, <em>{{'TOOLBAR.ADMIN' | translate}}</em></span><br>
                      </ng-container>
                      {{datosUsuario.nombre}}
                    </span>
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

                <!-- <button mat-menu-item>
                    <mat-icon>account_circle</mat-icon>
                    <span>{{'TOOLBAR.PERFIL' | translate}}</span>
                </button>

                <button mat-menu-item class="">
                    <mat-icon>mail</mat-icon>
                    <span>{{'TOOLBAR.INBOX' | translate}}</span>
                </button> -->

                <button mat-menu-item class="" (click)="cerrarSesion()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>{{'TOOLBAR.LOGOUT' | translate}}</span>
                </button>
                <button mat-menu-item class="" (click)="myprofile()" *ngIf="showProfile">
                    <mat-icon>account_circle</mat-icon>
                    <span>{{'TOOLBAR.PERFIL' | translate}}</span>
                </button>
                <!--<button mat-menu-item class="" (click)="cerrarSesion()">
                    <mat-icon>account_circle</mat-icon>
                    <span>{{'TOOLBAR.GOPROFILE' | translate}}</span>
                </button>-->

            </mat-menu>

            <div *ngIf="iconoNotificaciones" class="toolbar-separator"></div>
              <ng-container *ngIf="!notifEmpresa">
                <button *ngIf="iconoNotificaciones" mat-icon-button class="quick-panel-toggle-button" (click)="toggleSidebarOpen('quickPanel')" aria-label="Toggle quick panel">
                  <mat-icon *ngIf="notificaciones > 0" class="secondary-text s-30" matBadge="{{notificaciones}}" matBadgePosition="before" matBadgeColor="primary">notifications_active</mat-icon>
                  <mat-icon *ngIf="notificaciones == 0" class="secondary-text s-30" matBadgePosition="before" matBadgeColor="primary">notifications_active</mat-icon>
                </button>

              </ng-container>
              <ng-container *ngIf="notifEmpresa">
                <button *ngIf="iconoNotificaciones" mat-icon-button class="quick-panel-toggle-button" (click)="toggleSidebarOpen('quickPanel')" aria-label="Toggle quick panel">
                  <mat-icon *ngIf="notificacionesEmpresa > 0" class="secondary-text s-30" matBadge="{{notificacionesEmpresa}}" matBadgePosition="before" matBadgeColor="primary" id="icon_class">notifications_active</mat-icon>
                  <mat-icon *ngIf="notificacionesEmpresa == 0" class="secondary-text s-30" matBadgePosition="before" matBadgeColor="primary">notifications_active</mat-icon>
                </button>
              </ng-container>

            <!-- <button  mat-icon-button class="quick-panel-toggle-button" (click)="toggleSidebarOpen('quickPanel')" aria-label="Toggle quick panel">
                <mat-icon *ngIf="notificaciones > 0" class="secondary-text s-30" matBadge="{{notificaciones}}" matBadgePosition="before" matBadgeColor="primary">view_headline</mat-icon>
                <mat-icon *ngIf="notificaciones == 0" class="secondary-text s-30" matBadgePosition="before" matBadgeColor="primary">view_headline</mat-icon>
            </button> -->



        </div>

    </div>

</mat-toolbar>
